export function createEvent(typeArg: string, eventInit?: EventInit) {
  try {
    return new Event(typeArg, eventInit);
  } catch (error) {
    const event = document.createEvent("Event");
    const bubbles = Boolean(!eventInit || eventInit.bubbles);
    const cancelable = Boolean(!eventInit || eventInit.cancelable);
    event.initEvent(typeArg, !bubbles, !cancelable);
    return event;
  }
}
